<template lang="pug">
    div
        h1 Players
        
        
        div.boxes
            key-stat-box(title="Registered Players (live)",:value="formatBigNumber(keyStats.registeredPlayers)")
            key-stat-box(title="Currently playing (live)",:value="formatBigNumber(keyStats.currentPlayers)")


        h2 Players (Total)
        date-bar-chart(:query="sqlTotalPlayers")

        h2 Players (Web)
        date-bar-chart(:query="sqlWebPlayers")

        h2 Players (Steam)
        date-bar-chart(:query="sqlSteamPlayers")

        h2 Players (Beta)
        date-bar-chart(:query="sqlBetaPlayers")


</template>

<script>
import DateFilter from "../components/DateFilter";
import KeyStatBox from "../components/KeyStatBox";
import DateBarChart from "../components/DateBarChart";
import ApiService from "../services/api";

import {
  formatBigNumber,
  formatSecondsShort,
  formatPercentage
} from "../utils";

export default {
  components: { KeyStatBox, DateFilter, DateBarChart },
  data: () => ({
    keyStats: {
      registeredPlayers: null,
      currentPlayers: null
    },

    sqlTotalPlayers: `
      select max(pc.total_count)::int as y from player_counts pc
      where pc.time > START and pc.time <= END
    `,

    sqlWebPlayers: `
      select max(pc.web_count)::int as y from player_counts pc
      where pc.time > START and pc.time <= END
    `,

    sqlSteamPlayers: `
      select max(pc.steam_count)::int as y from player_counts pc
      where pc.time > START and pc.time <= END
    `,

    sqlBetaPlayers: `
      select max(pc.beta_count)::int as y from player_counts pc
      where pc.time > START and pc.time <= END
    `
  }),

  mounted() {
    this.refreshInterval = setInterval(this.refreshCcu.bind(this), 5000);
    this.refreshCcu();
  },

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },

  methods: {
    formatBigNumber,
    formatSecondsShort,
    formatPercentage,

    async refreshCcu() {
      this.keyStats.registeredPlayers = (
        await ApiService.query("select count(*)::int from players")
      )[0].count;

      this.keyStats.currentPlayers = (
        await ApiService.query(
          "select count(*)::int from games where updated > (now() - interval '5 minute')"
        )
      )[0].count;
    }
  }
};
</script>